import React from 'react'
import PropTypes from 'prop-types';
import DemandApproval from "./DemandApproval";


function Index(
    {
        expanded
    }) {
    return expanded && <DemandApproval />
}

Index.propTypes = {
    expanded: PropTypes.bool,
}

export default Index;